import React from 'react';
import { GroupProtectedRoute } from '../../components/auth/GroupProtectedRoute';
import { FEATURE_GROUPS } from '../../features.config';

export const DeficitsRoutes: React.FC = () => (
  <GroupProtectedRoute requiredGroup={FEATURE_GROUPS.deficits}>
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <p className="text-muted">Deficits — coming soon.</p>
    </div>
  </GroupProtectedRoute>
);
